export default {
    title: "Title:",
    tilefono: "Phone:",
    email: "Email:",
    ktirio: "Building",
    mprostiniOpsi: "Front side of the university",
    grafeio: "Office:",
    epikoinonisteMe: "Contact with",
    tonTinKathigiti: "the professor",
    searchProf: "Enter name, surname or email",
    noResults: "No results found",
    grammateia: "Secretariat:",
    istoselidaGrammateias: "Visit secretariat's website",
    ies_department: "International and European Studies",
    bso_department: "Balkan, Slavic & Oriental Studies",
    eco_department: "Department of Economics",
    dai_department: "Applied Informatics",
    ba_department: "Business Administration",
    fin_department: "Accounting and Finance",
    esp_department: "Educational & Social Policy",
    msa_department: "Music Science & Art",
    kosmitoras: "Dean",
    proedrosTmimatos: "Dean",
    kathigitis: "Professor",
    kathigitria: "Professor",
    anaplirotisKathigitis: "Deputy Professor",
    epikouriKathigitria: "Assistant Professor",
    epikourosKathigitis: "Assistant Professor",
    katerina: "Katerina",
    kyrtsou: "Kyrtsou",
    erotokritos: "Erotokritos",
    varelas: "Varelas",
    konstantinos: "Konstantinos",
    velentzas: "Velentzas",
    dimitrios: "Dimitrios",
    ioannidis: "Ioannidis",
    giannis: "Giannis",
    karagiannis: "Karagiannis",
    karfakis: "Karfakis",
    christos: "Christos",
    constantatos: "Konstantatos",
    stelios: "Stelios",
    katranidis: "Katranidis",
    ioannis: "Ioannis",
    mourmouras: "Mourmouras",
    agelike: "Agelike",
    nikolaou: "Nikolaou",
    anastasios: "Anastasios",
    economides: "Economides",
    theodore: "Theodore",
    panagiotidis: "Panagiotidis",
    eftihios: "Eftihios",
    sartzetakis: "Sartzetakis",
    lefteris: "Lefteris",
    tsoulfidis: "Tsoulfidis",
    stylianos: "Stylianos",
    fountas: "Fountas",
    theologos: "Theologos",
    pantelidis: "Pantelidis",
    maria: "Maria",
    alipranti: "Alipranti",
    anastasia: "Anastasia",
    litina: "Litina",
    spyridon: "Spyridon",
    boikos: "Boikos",
    eleftherios: "Eleftherios",
    filippiadis: "Filippiadis",
    revekka: "Revekka",
    christopoulou: "Christopoulou",
    fotini: "Fotini",
    tsibiridou: "Tsibiridou",
    tsitselikis: "Tsitselikis",
    eleni: "Eleni",
    gavra: "Gavra",
    sofia: "Sofia",
    delipalla: "Delipalla",
    alexandra: "Alexandra",
    ioannidou: "Ioannidou",
    kiriakos: "Kyriakos",
    kentrotis: "Kentrotis",
    thanasis: "Athanasios",
    koulakiotis: "Koulakiotis",
    kirkilis: "Kyrkilis",
    marangos: "Marangos",
    nikolaos: "Nikolaos",
    marantzidis: "Marantzidis",
    nihoritis: "Nihoritis",
    harry: "Harry",
    papapanagos: "Papapanagos",
    paraskevopoulos: "Paraskevopoulos",
    aikaterini: "Aikaterini",
    sarri: "Sarri",
    fotios: "Fotios",
    siokis: "Siokis",
    stamatopoulos: "Stamatopoulos",
    tzionas: "Tzionas",
    akrivoulis: "Akrivoulis",
    vlasios: "Vlasios",
    vlasidis: "Vlasidis",
    zaikos: "Zaikos",
    emmanouil: "Emmanouil",
    karpetis: "Karpetis",
    manos: "Manos",
    stavroula: "Stavroula",
    mavrogeni: "Mavrogeni",
    panagiotis: "Panagiotis",
    michailidis: "Michailidis",
    panopoulos: "Panopoulos",
    tsiprian: "Tsiprian - Loukretsious",
    soutsiou: "Soutsiou",
    georgios: "Yorgos",
    christidis: "Christidis",
    stratos: "Stratos",
    dordanas: "Dordanas",
    leonidas: "Leonidas",
    karakatsanis: "Karakatsanis",
    liazos: "Liazos",
    sideri: "Sideri",
    john: "John",
    nikas: "Nikas",
    zafeiropoulos: "Zafiropoulos",
    karvounarakis: "Karvounarakis",
    theodosios: "Theodosios",
    litsas: "Litsas",
    aristeidis:"Aristeidis",
    mpitzenis: "Mpitzenis",
    skiadas: "Skiadas",
    spiropoulos: "Spiropoulos",
    despina: "Despina",
    anagnostopoulou: "Anagnostopoulou",
    voskopoulos: "Voskopoulos",
    apostolos: "Apostolos",
    kiohos: "Kiochos",
    koutsoupias: "Koutsoupias",
    konstantinidis: "Konstantinidis",
    makris: "Makris",
    pedi: "Pedi",
    papadopoulos: "Papadopoulos",
    vasileiadis: "Vasileiadis",
    dergiades: "Dergiades",
    mikelis: "Mikelis",
    mpellou: "Mpellou",
    mpozinis: "Mpozinis",
    mpoutsiouki: "Mpoutsiouki",
    skeuas: "Skevas",
    kalliopi: "Kalliopi",
    hainoglou: "Hainoglou",
    agaliotis: "Agaliotis",
    euthimios: "Efthimios",
    valkanos: "Valkanos",
    areti: "Areti",
    okalidou: "Okalidou",
    platsidou: "Platsidou",
    psalti: "Psalti",
    eirini: "Irini",
    gouleta: "Gouleta",
    leukothea: "Lefkothea",
    kartasidou: "Kartasidou",
    koustriava: "Koustriava",
    papavasileiou: "Papavasileiou",
    doxa: "Doxa",
    papakonstantinou: "Papakonstantinou",
    harikleia: "Chariklia",
    proiou: "Proiou",
    miltiadis: "Miltiadis",
    stampoulis: "Stampoulis",
    christina: "Christina",
    syriopoulou_delli: "Siriopoulou - Delli",
    fahantidis: "Fachantidis",
    varsamis: "Varsamis",
    vasiliki: "Vasiliki",
    giannouli: "Giannouli",
    sitziouki: "Sitziouki",
    chatzigeorgiou: "Chatzigeorgiou",
    evgenia: "Evgenia",
    alexandropoulou: "Alexandropoulou",
    maro: "Maro",
    vlachopoulou: "Vlachopoulou",
    georgiadis: "Georgiadis",
    evaggelidis: "Evaggelidis",
    margaritis: "Margaritis",
    mavridis: "Mavridis",
    nikolaidis: "Nikolaidis",
    refanidis: "Refanidis",
    roumeliotis: "Roumeliotis",
    samaras: "Samaras",
    satratzemi: "Satratzemi",
    steiakakis: "Steiakakis",
    tampouris: "Tampouris",
    hristou_varsakelis: "Hristou - Varsakelis",
    vergidis: "Vergidis",
    dasilas: "Dasilas",
    kaskalis: "Kaskalis",
    kitsios: "Kitsios",
    mamatas: "Mamatas",
    xinogalos: "Xinogalos",
    papadimitriou: "Papadimitriou",
    aggelos: "Aggelos",
    sifaleras: "Sifaleras",
    antonios: "Antonios",
    stauropoulos: "Stavropoulos",
    fouskas: "Fouskas",
    psannis: "Psannis",
    ampatzoglou: "Ampatzoglou",
    giannoutakis: "Giannoutakis",
    georgia: "Georgia",
    koloniari: "Koloniari",
    michail: "Michail",
    mantas: "Mantas",
    petridou: "Petridou",
    ilias: "Ilias",
    sakellariou: "Sakellariou",
    stavros: "Stavros",
    souravlas: "Souravlas",
    fouliras: "Fouliras",
    gkinoglou: "Gkinoglou",
    achilleas: "Achilleas",
    zapranis: "Zapranis",
    negkakis: "Negakis",
    noulas: "Noulas",
    papanastasiou: "Papanastasiou",
    protogeros: "Protogeros",
    tachynakis: "Tachynakis",
    alexandridis: "Alexandridis",
    efstratios: "Efstratios",
    livanis: "Livanis",
    mavragani: "Mavragani",
    messis: "Messis",
    petros: "Petros",
    simeon: "Simeon",
    odysseas: "Odysseas",
    pavlatos: "Pavlatos",
    tziogkidis: "Tziogkidis",
    trachanas: "Trachanas",
    vranos: "Vranos",
    zervas: "Zervas",
    kiriakakis: "Kyriakakis",
    hans_ouve: "Hans - Uwe",
    papamatthaiou_matske: "Papamattheou - Matschke",
    kiriakos_nektarios: "Kyriakos - Nektarios",
    paris: "Paris",
    patras: "Patras",
    eugenios: "Evgenios",
    politis: "Politis",
    lelouda: "Lelouda",
    stamou: "Stamou",
    katrin_annete: "Katrin - Annette",
    handrakis: "Handrakis",
    hasiotis: "Hasiotis",
    atzakas: "Atzakas",
    germanos: "Germanos",
    ahalinotopoulos: "Ahalinotopoulos",
    vouvaris: "Vouvaris",
    aggeliki: "Aggeliki",
    kathariou: "Kathariou",
    moumoulidis: "Moumoulidis",
    papandreou: "Papandreou",
    igor: "Igor",
    petrin: "Petrin",
    anna_maria: "Anna - Maria",
    rentzeperi: "Rentzeperi",
    sokratis: "Socrates",
    sinopoulos: "Sinopoulos",
    zarias: "Zarias",
    zgouras: "Zgouras",
    kallimopoulou: "Kallimopoulou",
    maria_emma: "Maria - Emma",
    meligkopoulou: "Meligkopoulou",
    raptis: "Raptis",
    tsikouridis: "Tsikouridis",
    aletras: "Aletras",
    andreas: "Andreas",
    andronikidis: "Andronikidis",
    vouzas: "Vouzas",
    georgiou: "Georgiou",
    gkotzamani: "Gkotzamani",
    iordanis: "Iordanis",
    moschidis: "Moschidis",
    soumpeniotis: "Soumpeniotis",
    tarampanis: "Tarampanis",
    tsiotras: "Tsiotras",
    rodoula: "Rodoula",
    tsiotsou: "Tsiotsou",
    chatzidimitriou: "Chatzidimitriou",
    agorastos: "Agorastos",
    katou: "Katou",
    iason: "Iason",
    papathanasiou: "Papathanasiou",
    loukas: "Loukas",
    tsironis: "Tsironis",
    grougiou: "Grougiou",
    drogalas: "Drogalas",
    euaggelos: "Evangelos",
    kalampokis: "Kalampokis",
    kaparis: "Kaparis",
    kafetzopoulos: "Kafetzopoulos",
    konstantaras: "Konstantaras",
    tampakoudis: "Tampakoudis",
    chatzithomas: "Chatzithomas",
    kourdoumpalou: "Kourdoumpalou",
    alexandros: "Alexandros",    
    theodoros: "Theodoros",
    vasileios: "Vasileios",
    eleftheriadis: "Eleftheriadis",
    samara: "Samara",
    tsents: "Zenz",
    elena: "Elena",
    ioanna: "Ioanna"
};
